export const actions = {
   GET_LEARNING_OUTCOMES_LIST: 'GET_LEARNING_OUTCOMES_LIST',
   ADD_LEARNING_OUTCOMES: 'ADD_LEARNING_OUTCOMES',
   DELETE_LEARNING_OUTCOMES: 'DELETE_LEARNING_OUTCOMES',
   UPDATE_LEARNING_OUTCOMES: 'UPDATE_LEARNING_OUTCOMES',
   ADD_COURSE_DEPENDENCY_LEARNING_OUTCOMES: 'ADD_COURSE_DEPENDENCY_LEARNING_OUTCOMES',
   SET_LEARNING_OUTCOMES: 'SET_LEARNING_OUTCOMES',
   ADD_LEARNING_OUTCOMES_FOR_ACTIVITY: 'ADD_LEARNING_OUTCOMES_FOR_ACTIVITY',
   ADD_LEARNING_OUTCOMES_FOR_QUESTION: 'ADD_LEARNING_OUTCOMES_FOR_QUESTION',
};